import React from 'react';
import { createSlice } from "@reduxjs/toolkit";
import { message } from 'antd';

const AuthReducer = createSlice({
  name: "AuthReducer",
  initialState: {
    loading: false,
    error: false,
    success: false,
    user: null,
    dwollaBalance: 0
  },
  reducers: {
    loginSubmit: (state) => {
      state.loading = true;
    },
    loginSuccess: (state, { payload }) => {
      state.loading = false;
      state.user = payload.user;
      state.success = true;
      state.error = false;
      state.dwollaBalance = 0;
    },
    loginError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
    },
    oAuthLoginSubmit: (state) => {
      state.loading = true;
    },
    oAuthLoginSuccess: (state, { payload }) => {
      state.loading = false;
      state.user = payload.user || payload.createdUser;
      state.success = true;
      state.error = false;
      state.dwollaBalance = 0;
    },
    oAuthLoginError: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.success = false;
      message.error(action?.payload?.message || "Unable to login");
    },
    logoutUser: (state) => {
      state.user = null;
      state.error = false;
      state.success = false;
      state.loading = false;
    },
    getUserRequest: (state) => {
      state.loading = true;
    },
    getUserSuccess: (state, { payload }) => {
      state.loading = false;
      state.error = false;
      state.user = payload.user;
      state.success = true;
    },
    getUserError: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
      state.user = null;
      state.success = false;
    },
    updateUser: (state, { payload }) => {
      state.user = payload;
    },
    getDwollaBalanceRequest: (state) => {
      state.loading = true;
    },
    getDwollaBalanceSuccess: (state, { payload }) => {
      state.loading = false;
      state.dwollaBalance = Number(payload?.amount || 0);
    },
    getDwollaBalanceError: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    updateDwollaBalance: (state, { payload }) => {
      state.dwollaBalance = payload;
      message.success("Donation successfull")
    },
  },
});

export const {
  loginSubmit,
  loginSuccess,
  loginError,
  logoutUser,
  getUserRequest,
  getUserSuccess,
  getUserError,
  updateUser,
  getDwollaBalanceRequest,
  getDwollaBalanceSuccess,
  getDwollaBalanceError,
  updateDwollaBalance,
  oAuthLoginSubmit,
  oAuthLoginSuccess,
  oAuthLoginError

} = AuthReducer.actions;

export default AuthReducer.reducer;
